import { ChartData } from 'chart.js';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { CHART_NEUTRAL, CHART_SERIES } from 'src/styles/chartTheme';

export const demoDonutChartData = {
  labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
  datasets: [
    {
      data: [67, 20, 8, 5],
      backgroundColor: [CHART_SERIES.light[0], CHART_SERIES.light[1], CHART_SERIES.light[3], CHART_NEUTRAL.light],
    },
  ],
};

const options = {
  maintainAspectRatio: false,
  aspectRatio: 1,
  borderWidth: 0,
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
  },
};

const DoughnutChart: React.FC<{
  data: ChartData<'doughnut', number[], string>;
}> = ({ data }) => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', contain: 'inline-size' }}>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DoughnutChart;
